import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "./ui/carousel";
import { IMAGES } from "../lib/business";

const SLIDES = [
  { src: IMAGES.speedway, title: "Speedway Earlwood", sub: "Open 24/7 · Fill up $5+ & save $5 on your wash" },
  { src: IMAGES.autoWash, title: "Automatic Car Wash", sub: "Open 24/7 · From $6" },
  { src: IMAGES.selfServe, title: "Self-Serve Bays", sub: "6AM – 10PM · From $6 / 5 min" },
  { src: IMAGES.vacuumMat, title: "Vacuums & Mat Cleaner", sub: "Vacuum $2 / 5 min · Mat cleaner $1 / 1.5 min" },
  { src: IMAGES.dogWash, title: "K9000 Dog Wash", sub: "Open 24/7 · $10 / 10 min" },
];

export function PhotoGallery() {
  return (
    <section className="mx-auto max-w-7xl px-6 pb-20" data-testid="photo-gallery">
      <div className="overline text-volt mb-3">Gallery</div>
      <h2 className="font-head font-extrabold text-3xl md:text-4xl uppercase tracking-tight mb-10">See Our Site</h2>
      <Carousel opts={{ loop: true, align: "start" }} className="relative">
        <CarouselContent>
          {SLIDES.map((s, i) => (
            <CarouselItem key={s.title} className="md:basis-4/5 lg:basis-2/3" data-testid={`gallery-slide-${i}`}>
              <div className="relative h-[320px] md:h-[480px] overflow-hidden border border-white/10">
                <img src={s.src} alt={s.title} className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-black via-black/60 to-transparent">
                  <h3 className="font-head font-bold text-2xl uppercase tracking-tight">{s.title}</h3>
                  <p className="overline text-volt mt-1">{s.sub}</p>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious data-testid="gallery-prev-btn" className="left-3 rounded-none bg-black/70 border-white/20 hover:bg-volt" />
        <CarouselNext data-testid="gallery-next-btn" className="right-3 rounded-none bg-black/70 border-white/20 hover:bg-volt" />
      </Carousel>
    </section>
  );
}
